// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__Ac87N","imageContainer":"styles_imageContainer__Fdgjq","image":"styles_image__5kjSK","back":"styles_back__OfyQw","text":"styles_text__1TEY6"};